module.exports = __webpack_public_path__ + "static/media/order_icon5.20d7313b.png";